// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ND2K","desktopLogo":"styles_desktopLogo__3KJve"};